import { ChangeDetectionStrategy, Component, ContentChildren, ElementRef, HostListener, Inject, TemplateRef, ViewChildren, ViewContainerRef, contentChildren, inject, viewChild, input } from '@angular/core';
import { CdkMenuTrigger } from '@angular/cdk/menu';
import { ChildrenAnimation, fadeUpDown } from '@ex/module/shared/animations/allAnimations';

@Component({
    selector: 'zen-menu',
    templateUrl: './menu.component.html',
    styleUrl: './menu.component.scss',
    animations: [fadeUpDown, ChildrenAnimation],
    standalone: false
})
export class MenuComponent {
  readonly isDisabled = input(false);
  readonly disableCaret = input(false);
  readonly iTrigger = viewChild.required(CdkMenuTrigger);
  
  handleClick(event: any) {
    if (event.target.tagName.toLowerCase() === 'a')
      this.iTrigger().close();
  }
  get dir() {
    return document.body.dir;
  }

}
